<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="往来单位"
      :expand-all-row="false"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="true"
      :get-data-func="api.list"
      :show-expand="true"
      :unitList="unitListFun"
      @expand-change="expandChange"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="供应商名称">
          <el-input
            size="mini"
            clearable
            v-model="params.name"
            placeholder="请输入供应商名称"
          />
        </el-form-item> -->
        <el-form-item label="单据编号">
          <el-input
            size="mini"
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <!-- <el-form-item label="商品名称">
          <el-input
            size="mini"
            clearable
            v-model="params.name"
            placeholder="请输入商品名称"
          />
        </el-form-item> -->
        <el-form-item label="订单日期">
          <el-date-picker
            size="mini"
            v-model="params.DeliveryDateStart"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          -
          <el-date-picker
            size="mini"
            v-model="params.DeliveryDateEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="单位编码">
          <el-input size="mini" clearable v-model="params.Code" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label="单位名称">
          <el-input size="mini" clearable v-model="params.Name" placeholder="请输入单位名称" />
        </el-form-item> -->
        <!-- <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input size="mini" clearable v-model="params.Model" placeholder="请输入规格型号" />
        </el-form-item>
        <el-form-item label="商品标签">
          <el-input size="mini" v-model="params.Tags" placeholder="请选择商品标签" clearable />
        </el-form-item>
        <el-form-item label="商品状态" v-if="showStatus">
          <el-select size="mini" v-model="params.Status" placeholder="请选择商品状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{ row }">{{
            row.DocDate.split(" ")[0]
          }}</template>
        </el-table-column>
        <el-table-column prop="SupplierName" label="供应商名称">
          <template slot-scope="{ row }">{{ row.SupplierName }}</template>
        </el-table-column>
        <el-table-column prop="Amount" label="订单金额" />
        <el-table-column prop="UpdateTime" label="预计交货日期" />
        <el-table-column prop="Status" label="状态">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 0">草稿</span>
            <span v-else-if="row.Status == 1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
      <template slot="expand">
        <el-table-column type="selection" align="center" fixed width="40" />
        <el-table-column prop="GoodsName" label="商品名称" min-width="110px" />
        <el-table-column prop="UnitName" label="商品单位" min-width="160px" />
        <el-table-column
          prop="Quantity"
          label="商品数量"
          min-width="160px"
        />
        <el-table-column
          prop="TaxAmount"
          label="税额"
          min-width="160px"
        />
        <el-table-column
          prop="Amount"
          label="含税金额"
          min-width="160px"
        />
        <el-table-column
          prop="NoTaxAmount"
          label="不含税金额"
          min-width="160px"
        />
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    typeList: {
      default: () => [],
    },
  },
  beforeMount() {
    this.params.TradeUnitTypeList = this.typeList;
    if (this.typeList.length > 0) {
      this.v1 = this.typeList.indexOf(1) > -1;
      this.v2 = this.typeList.indexOf(2) > -1;
      this.v3 = this.typeList.indexOf(3) > -1;
    }
  },
  data() {
    return {
      unitList: {},
      api: require("@/api/purchase/order").default,
      sales: require("@/api/sale/sales").default,
      params: {
        TradeUnitType: null,
        TradeUnitTypeList: [],
        DocNo: "",
        DeliveryDateStart: "",
        DeliveryDateEnd: "",
        Code: "",
      },
      v1: true,
      v2: true,
      v3: true,
    };
  },
  methods: {
    unitListFun(data) {
      // 
      data.forEach((e) => {
        if (this.unitList.OrderId == e.OrderId && !e.expand) {
          e.DocNo = e.DocNo + " ";
          this.$set(e, 'expand', this.unitList.Data)
        }
      });
      this.$emit("table-change",data); 
      return data;
    },
    expandChange(row) {
      this.api.info(row.OrderId).then((res) => {
        res.Data.Goods.forEach(e=>{
          e.SupplierId=res.Data.SupplierId
          e.SupplierName=res.Data.SupplierName
        })
        this.unitList = { OrderId: row.OrderId, Data: res.Data.Goods };
        this.$nextTick(() => {
          this.$refs.list.getexpand()
        })
      });
    },
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
